import cn from 'classnames';
import { FC } from 'react';

import type { TranscriptorConsultation } from '@/entities/transcriptor';

import { useWorkspaceCatalog } from '../hooks';

import { CatalogRetry } from './CatalogRetry';
import { EncounterDocumentView } from './EncounterDocumentView';
import styles from './RecordingDocuments.module.scss';

type Props = {
  patientId: string;
  encounterId: string;
  encounter: TranscriptorConsultation | undefined;
  canEdit: boolean;
  canRecord: boolean;
  className?: string;
};

// One recording's documents on its page, with the clinic's catalog they are
// read against.
export const RecordingDocuments: FC<Props> = ({
  patientId,
  encounterId,
  encounter,
  canEdit,
  canRecord,
  className,
}) => {
  const { schemas, documentTemplates, loadError, retry } =
    useWorkspaceCatalog();

  return (
    <div
      className={cn(styles.documents, className)}
      data-component="recording-documents"
    >
      {loadError && <CatalogRetry onRetry={retry} />}
      <EncounterDocumentView
        key={encounterId}
        patientId={patientId}
        encounterId={encounterId}
        encounter={encounter}
        schemas={schemas}
        documentTemplates={documentTemplates}
        canEdit={canEdit}
        canRecord={canRecord}
      />
    </div>
  );
};
